var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('div',{staticClass:"editorx_body"},[_c('div',{attrs:{"id":("codex-editor-" + _vm.id)}})]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }